var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"information-full"},[_c('CMobileTabs',{attrs:{"options":_setup.LIST_DATA,"active":_setup.activeId,"labelKey":"name","syncKey":"id"},on:{"update:active":function($event){_setup.activeId=$event}}}),_c(_setup.componentMap[_setup.activeId],{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }